/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["crupdate-subscription-modal{display:block}crupdate-subscription-modal .date-picker-input-container{position:relative}crupdate-subscription-modal .date-picker-input-container .mat-datepicker-toggle{position:absolute;top:29px;right:0}crupdate-subscription-modal .mat-autocomplete-panel .mat-progress-bar{position:absolute;top:0;left:0}"];
export { styles as styles };
